import { chatbotFlexAssets } from '../chatbot/flex';
import {
  nativeShareInviteAssets,
  sharePickerInviteAssets,
} from '../chatbot/flex/invite';
import { chatbotSimpleAssets } from '../chatbot/simple';

export const profileAvatarAssets = new Array(55).fill(null).reduce(
  (acc, _, index) => ({
    ...acc,
    [`avatar-${index + 1}`]: `private/avatar/${index + 1}.png`,
  }),
  {},
);

// Export for replicant
export const replicantAssets = {
  // Simple assets
  ...chatbotSimpleAssets,

  // Flex assets
  ...chatbotFlexAssets,

  // Profile pictures
  ...profileAvatarAssets,

  // Share picker creative assets
  ...sharePickerInviteAssets,
};

export type ReplicantAssetKey = keyof typeof replicantAssets;
